import { NgModule } from '@angular/core';

import { SharedModule } from '../shared/shared.module';
import { AuthRoutingModule } from './auth-routing.module';
import { LoginFormComponent } from './login/login-form/login-form.component';
import { LoginComponent } from './login/login.component';
import { LogoutComponent } from './logout/logout.component';
import { RecoverPasswordDoneComponent } from './recover-password/recover-password-done/recover-password-done.component';
import { RecoverPasswordFormComponent } from './recover-password/recover-password-form/recover-password-form.component';
import { RecoverPasswordComponent } from './recover-password/recover-password.component';
import { ResetPasswordDoneComponent } from './reset-password/reset-password-done/reset-password-done.component';
import { ResetPasswordFormComponent } from './reset-password/reset-password-form/reset-password-form.component';
import { ResetPasswordInvalidComponent } from './reset-password/reset-password-invalid/reset-password-invalid.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { ResetPasswordResolver } from './reset-password/reset-password.resolver';

@NgModule({
  declarations: [
    LoginComponent,
    LoginFormComponent,
    LogoutComponent,
    RecoverPasswordComponent,
    RecoverPasswordDoneComponent,
    RecoverPasswordFormComponent,
    ResetPasswordComponent,
    ResetPasswordFormComponent,
    ResetPasswordDoneComponent,
    ResetPasswordInvalidComponent
  ],
  imports: [
    AuthRoutingModule,
    SharedModule
  ],
  providers: [
    ResetPasswordResolver
  ]
})
export class AuthModule { }



// WEBPACK FOOTER //
// /var/www/lantago-app/lantago-app-demo/src/app/auth/auth.module.ts